import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { PrintService } from 'src/app/core/services/print.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { AccountService } from 'src/app/services/account.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { ComplaintBookService } from 'src/app/services/complaint-book.service';
import Swal from 'sweetalert2';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-complaint-response',
  templateUrl: './complaint-response.component.html',
  styleUrls: ['./complaint-response.component.scss']
})
export class ComplaintResponseComponent implements OnInit {
  /**Es cliente? */
  isClient: boolean = false;
  /**Modo de modal */
  mode: string;
  /**Id de operación */
  operationId: string = '';
  /**Número de reclamo */
  complaintNumber: string = '';
  /**Fecha de reclamo */
  operationDateTime: Date;
  bandera: boolean;
  isComplaintExternal: boolean;
  allowedEmail: boolean;
  emailContact: string;
  // Utiliza ViewChild para obtener una referencia al modelo NgModel
  @ViewChild('emailContactModel', { static: false }) emailContactModel: NgModel;

  constructor(private printService: PrintService,
    @Inject(MAT_DIALOG_DATA) private input: any,
    private dialogRef: MatDialogRef<ComplaintResponseComponent>,
    private router: Router,
    private environmentService: EnvironmentService,
    private accountService: AccountService,
    private authService: AuthService,
    private complaintBookService: ComplaintBookService) { }

  ngOnInit() {
    this.operationId = this.input.operationId;
    this.complaintNumber = this.input.complaintNumber;
    this.operationDateTime = this.input.operationDateTime;
    this.mode = this.input.mode;
    this.isClient = this.input.isClient;
    this.bandera = this.accountService.getBandera();
    this.isComplaintExternal = this.input.isComplaintExternal;
  }

  openPrintWindow() {
    this.printService.generateComplaintRequest(this.input.complaint, this.input.operationDateTime, this.input.complaintNumber, this.input.operationId);
  }
  dowloandPdf() {

    const URL_DOWLOAND = `${this.environmentService.virtualOfficeServiceUrl}ComplaintBook/DownloadPdfComplaint/${this.input.complaintNumber}`;

    window.open(URL_DOWLOAND, '_blank');
    this.close();

  }

  sendEmail() {
    if (this.emailContactModel.valid) {
       
      this.complaintBookService.GetSendEmailPDF(this.emailContact, this.complaintNumber).subscribe((data) => {
        if (data.valid)
          Swal.fire('Información', 'se ha enviado correctamente el correo.', 'info').then(()=> {
          this.close();
        });

    })
  }else{

  Swal.fire('Error', 'Ingrese un correo.', 'error');

}


  }
close() {
  //console.log("bandera",this.bandera)

  var rec = localStorage.getItem("rec");

  if (this.authService.IsStandaloneModule() && this.bandera) {

    window.location.reload();
    this.router.navigate(['stdln/registrar-reclamo']);
  }
  else if (rec || (!this.bandera && this.authService.IsStandaloneModule()) || this.isComplaintExternal) {
    //window.location.reload();   
    //window.location.href = "https://portaldev3.calidda.com.pe:8081/atencion-al-cliente/reclamos#seccion";        
    //Descomentar para producción
    localStorage.clear();
    window.location.href = this.environmentService.portalWebUrl;
  }
  else {
    this.router.navigate(['/ofivirtual']);
  }
  this.dialogRef.close();
}
}
//